import ImageWithBasePath from "@/components/image-with-base-path"

const TeamSection = () => {
  return (
   <>
  {/* Team Section */}
  <section className="work-section-fourteen section">
    <div className="container">
      <div
        className="section-header section-header-fourteen text-center wow fadeInUp"
        data-wow-duration="1s"
      >
        <h2 className="section-title">
          How Booking <span className="section-line">Process</span>{" "}
          <span className="subtitle">Works For You</span>
        </h2>
      </div>
      <div className="work-sec">
        <div className="row g-4">
          {/* Work Item */}
          <div
            className="col-xl-3 col-sm-6 d-flex wow fadeInUp"
            data-wow-delay="0.2s"
            data-wow-duration="1s"
          >
            <div className="work-wrap flex-fill">
              <div className="work-way">
                <span className="circle-icon" />
                <span className="step">Step 1</span>
              </div>
              <div className="work-item-fourteen">
                <div className="work-img">
                  <ImageWithBasePath
                    src="assets/img/service/work-01.jpg"
                    alt="work"
                    className="img-fluid"
                  />
                </div>
                <div className="work-content">
                  <h3 className="custom-title">Choose Your Service</h3>
                  <p>
                    Select the dermatology treatment you need skin consultation,
                    acne treatment, hair care.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Work Item End */}
          {/* Doctor Item */}
          <div
            className="col-xl-3 col-sm-6 d-flex wow fadeInUp"
            data-wow-delay="0.4s"
            data-wow-duration="1s"
          >
            <div className="work-wrap work-02 flex-fill">
              <div className="work-way">
                <span className="circle-icon" />
                <span className="step">Step 2</span>
              </div>
              <div className="work-item-fourteen">
                <div className="work-img">
                  <ImageWithBasePath
                    src="assets/img/service/work-02.jpg"
                    alt="work"
                    className="img-fluid"
                  />
                </div>
                <div className="work-content">
                  <h3 className="custom-title">Pick Date &amp; Time</h3>
                  <p>
                    Choose your preferred appointment date and time that fits
                    your schedule easily.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Doctor Item End */}
          {/* Doctor Item */}
          <div
            className="col-xl-3 col-sm-6 d-flex wow fadeInUp"
            data-wow-delay="0.6s"
            data-wow-duration="1s"
          >
            <div className="work-wrap work-03 flex-fill">
              <div className="work-way">
                <span className="circle-icon" />
                <span className="step">Step 3</span>
              </div>
              <div className="work-item-fourteen">
                <div className="work-img">
                  <ImageWithBasePath
                    src="assets/img/service/work-03.jpg"
                    alt="work"
                    className="img-fluid"
                  />
                </div>
                <div className="work-content">
                  <h3 className="custom-title">Enter Details</h3>
                  <p>
                    Fill in your basic information and describe your skin
                    concern for better consultation.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Doctor Item End */}
          {/* Doctor Item */}
          <div
            className="col-xl-3 col-sm-6 d-flex wow fadeInUp"
            data-wow-delay="0.8s"
            data-wow-duration="1s"
          >
            <div className="work-wrap work-04 flex-fill">
              <div className="work-way">
                <span className="circle-icon" />
                <span className="step">Step 4</span>
              </div>
              <div className="work-item-fourteen">
                <div className="work-img">
                  <ImageWithBasePath
                    src="assets/img/service/work-04.jpg"
                    alt="work"
                    className="img-fluid"
                  />
                </div>
                <div className="work-content">
                  <h3 className="custom-title">Confirm Your Booking</h3>
                  <p>
                    Review your details and confirm your appointment. Get
                    instant confirmation and visit the clinic.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Doctor Item End */}
        </div>
      </div>
    </div>
  </section>
  {/* Team Section End */}
</>

  )
}

export default TeamSection